module.exports = __webpack_public_path__ + "std/img/guest-play-popup.bc3495a.webp";


//////////////////
// WEBPACK FOOTER
// ./src/pages/build800/assets/image/guest-play-popup.webp
// module id = VLWN
// module chunks = 0